import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorVotes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M8.528 12.682a.949.949 0 0 0 0 1.342l2.753 2.753a.948.948 0 0 0 1.434.018l2.757-2.757a.949.949 0 1 0-1.343-1.342l-1.173 1.173v-5.42a.95.95 0 0 0-1.901.002v5.415l-1.184-1.184a.949.949 0 0 0-1.343 0ZM4.5 17.25a.75.75 0 0 0-.67.415l-1.5 3A.75.75 0 0 0 3 21.75h18a.75.75 0 0 0 .67-1.085l-1.5-3a.75.75 0 0 0-.67-.415h-2.25a.75.75 0 0 0 0 1.5h1.787l.75 1.5H4.213l.75-1.5H6.75a.75.75 0 0 0 0-1.5H4.5Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12.935 4.155a1.284 1.284 0 0 0-1.87 0L4.15 11.328a1.473 1.473 0 0 0 0 2.02l5.707 5.902h4.322l5.668-5.9v-.001a1.473 1.473 0 0 0 0-2.021l-6.912-7.173Zm-2.95-1.041a2.784 2.784 0 0 1 4.03 0l6.914 7.173a2.973 2.973 0 0 1 0 4.102l-6.11 6.361H9.221l-6.15-6.36a2.973 2.973 0 0 1 0-4.103l6.914-7.173Z"
    />
  </svg>
);
export default SvgTwoColorVotes;
